module.exports = __webpack_public_path__ + "static/media/grid-4.7c93c18c.jpg";